import { EmployeeByActivityPoleFilterAtom } from '@/state/EmployeeByActivityPole.atom';

export const getQueryParams = (
	filteredData: EmployeeByActivityPoleFilterAtom,
) => {
	return {
		management: filteredData.management,
		workstation: filteredData.workstation,
		board: filteredData.board,
		jobTitle: filteredData.jobTitle,
		coordination: filteredData.coordination,
		pole: filteredData.pole,
		activity: filteredData.activity,
		conditionTraining: filteredData.conditionTraining,
		conditionStatus: filteredData.conditionStatus,
		showAllEmployees: filteredData.showAllEmployees,
		// employeeType: filteredData.employeeType, // TODO: uncomment this when we roll out third party control
	};
};
